import type { ReactNode } from 'react';
import React, { createContext, useCallback } from 'react';
import type { EventT, SendEventT } from './types';
type AnalyticsT = {
  sendEvent: (a: EventT) => void;
};
type PropsT = {
  sendEvent?: SendEventT;
  children: ReactNode;
};
export const AnalyticsContext = createContext<AnalyticsT>({
  sendEvent: (event: EventT) => {}
});
export const AnalyticsProvider = ({
  sendEvent,
  children
}: PropsT) => {
  const handleSendEvent = useCallback((event: EventT) => {
    sendEvent && sendEvent(event);
  }, [sendEvent]);
  return <AnalyticsContext.Provider value={{
    sendEvent: handleSendEvent
  }}>
      {children}
    </AnalyticsContext.Provider>;
};